import { LegacyCitationTypename, DashworksCitationTypename, WebPageCitationTypename, CrmCitationTypename } from 'chatspot-core/types/Sources';

// Type-safe mapping from CHIRP citation to core Citation
export const mapChirpCitationToCitationCore = chirpCitation => {
  let feedback;
  const chirpFeedback = chirpCitation.feedback;
  if (chirpFeedback) {
    feedback = {
      polarity: chirpFeedback.polarity,
      tags: chirpFeedback.tags,
      comment: chirpFeedback.comment
    };
  }
  switch (chirpCitation.__typename) {
    case DashworksCitationTypename:
      return Object.assign({}, chirpCitation, {
        __typename: DashworksCitationTypename,
        feedback
      });
    case WebPageCitationTypename:
      return Object.assign({}, chirpCitation, {
        __typename: WebPageCitationTypename,
        feedback
      });
    case CrmCitationTypename:
      return Object.assign({}, chirpCitation, {
        __typename: CrmCitationTypename,
        feedback
      });
    case LegacyCitationTypename:
    default:
      return Object.assign({}, chirpCitation, {
        __typename: LegacyCitationTypename,
        type: chirpCitation.type,
        feedback
      });
  }
};